import React from 'react';
import { Link as RouterLink } from 'react-router-dom'; // Import Link
import { Box, Typography, Container, Link, List, ListItem } from '@mui/material';

function HomePage() {
    return (
        <div>
            <Container maxWidth="md">
                <Box sx={{ my: 4 }}>
                    <Typography variant="h4" component="h1" gutterBottom>
                        Own Your Reputation, Accelerate Your Career
                    </Typography>
                    <Typography variant="body1" paragraph align="left">
                       You can't fix what you can't see. Your career is shaped by how others perceive you, but getting honest, structured feedback is nearly
                       impossible.  Your professional reputation is your single greatest asset, but are you managing it proactively or just letting it
                       happen?  Are you sure your professional brand is being received the way you intend?
                       <br />
                    </Typography>
                    <br />
                    <Typography variant="h6" gutterBottom align="left">
                       Radian will help.
                    </Typography>
                    <Typography variant="body1" paragraph align="left">
                       Radian is your personal reputation dashboard. We provide the 360° view you need to align your identity, reputation, and brand.
                       For the first time, the evidence-based tools used for C-suite development are available directly to you, for your own growth,
                       on your own terms. From self-perception to public perception and on to a cohesive brand strategy, Radian provides an end-to-end
                       toolkit for professional growth.
                       <br />
                    </Typography>
                    <Typography variant="h6" gutterBottom align="left">
                       Why Radian?
                    </Typography>
                    <Typography variant="body1" paragraph align="left">
                       <List dense sx={{ listStyleType: 'disc', pl: 4, mb: 2 }}>
                           <ListItem sx={{ display: 'list-item', p: 0}}><Typography variant="body1" color="text.secondary">For You, Not HR: This is your data, for your development. Radian is built for the individual, not for your boss's performance review file.</Typography></ListItem>
                           <ListItem sx={{ display: 'list-item', p: 0}}><Typography variant="body1" color="text.secondary">Holistic & Evidence-Based: Radian integrates validated models of communication, personality, and reputation into a single, cohesive platform.</Typography></ListItem>
                           <ListItem sx={{ display: 'list-item', p: 0}}><Typography variant="body1" color="text.secondary">Actionable Insights: It's not just data; it's a roadmap. Radian provides concrete feedback and AI-powered recommendations—including your own Brand Clarity strategy—to help you refine your brand and build a more powerful reputation.</Typography></ListItem>
                       </List>
                    </Typography>
                    <Typography variant="body1" paragraph align="left">
                       <br />
                       Visit our <Link href="https://radian.ooo/about">About page</Link> to learn the answers to frequently asked questions.
                       <br />
                       <br />
                       Still have questions? <Link href="mailto:ohhello@radian.ooo">Say hello!</Link>
                    </Typography>
                </Box>
            </Container>
        </div>
    );
}

export default HomePage;